import { GroupClient } from './GroupClient';
import HttpClient from '../../gateway/HttpClient';
import { notBlank, notUndefined } from '../../util/Assert';
import { Group } from '../../domain/rbac/RbacDomains';
import HttpMethod from '../../constant/HttpMethod';
import { GroupMethods } from '../../constant/MethodNames';
import { query } from '@trlogic/client-js';
import Query = query.Query;

class NestGroupClient implements GroupClient {
  private httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    notUndefined(httpClient, 'Http client cannot be undefined');
    this.httpClient = httpClient;
  }

  public exist(id: string): Promise<boolean> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.GET, `${GroupMethods.EXIST}`, {}, { id: id });
  }

  public save(id: string, group: Group): Promise<void> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    notUndefined(group, 'Group cannot be undefined');
    if (id.trim().length == 0) {
      id = group.name;
      group.id = group.name;
    }
    const dto = { id: id, group: group };
    return this.httpClient.execute(HttpMethod.POST, `${GroupMethods.SAVE}`, dto);
  }

  public getCount(query: Query): Promise<number> {
    notUndefined(query, 'Query cannot be undefined');
    return this.httpClient.execute(HttpMethod.GET, `${GroupMethods.COUNT}`, undefined, { query });
  }

  public getUserNames(groupId: string): Promise<string[]> {
    notUndefined(groupId, 'Group id cannot be undefined');
    notBlank(groupId, 'Group id cannot be blank');
    return this.httpClient.execute(HttpMethod.GET, `${GroupMethods.GET_USERNAMES}`, {}, { groups: groupId });
  }

  public remove(id: string): Promise<any> {
    notUndefined(id, 'Id cannot be undefined');
    return this.httpClient.execute(HttpMethod.DELETE, `${GroupMethods.REMOVE}/${id}`);
  }

  public getGroupNames(): Promise<string[]> {
    return this.httpClient.execute(HttpMethod.GET, GroupMethods.GET_NAMES);
  }
}

export default NestGroupClient;
